export default "__VITE_ASSET__CuxgpuCk__"